export const RENDER_ORDER = {
  PARTICLE: 10,
  DEFAULT: 10,
};
export const STATE_NAME = [
  '主页面',
  '仙灵岛',
  '苏州城',
  '杭州城',
  '蜀山',
  '归云村',
];
